<template>
  <form ref="form-userlogin" @submit.prevent="submit" v-form:form novalidate>
    <div class="form-row input-text-field" :class="{'is-error': showTouchedError('email') || isErrorForField('email')}">
      <label for="email">{{ $t('paywall.form.click2pay.loginForm.emailLabel') }}</label>
      <div class="input-text-wrapper" :class="{'is-error': showTouchedError('email') || isErrorForField('email')}">
        <input
          type="text"
          name="email"
          id="email"
          ref="email"
          required
          email
          :aria-invalid="getAriaInvalid('email')"
          :aria-describedby="getAriaDescribedBy('email')"
          v-model.trim="formData.email"
          :class="{ 'filled': formData.email }" />
        <span class="input-flow-label" aria-hidden="true">&nbsp;{{ $t('paywall.form.click2pay.loginForm.emailLabelFlow') }}<span class="required">*</span>&nbsp;</span>
      </div>
      <p role="alert"
         v-if="showTouchedError('email') || isErrorForField('email')"
         class="error"
         :id="getErrorId('email')"
         :aria-label="getFieldErrorAriaLabel('email', $t('paywall.form.click2pay.loginForm.emailLabelFlow'))">
        <span aria-hidden="true">{{ getFieldErrorText('email') }}</span>
      </p>
    </div>
    <div class="submit-wrapper">
      <div class="c2p-submit">
        <button type="submit" class="btn" :class="{'inactive': isFormInvalid()}" :disabled="processing">
          <span>{{ $t('paywall.form.click2pay.loginForm.buttonSubmit') }}</span>
        </button>
      </div>
    </div>
    <div class="c2p-back">
      <button type="button" @click="goBack" class="btn btn-plain">
        {{ $t('paywall.form.click2pay.loginForm.buttonBack') }}
      </button>
    </div>
  </form>
</template>

<script>
import formMixin from '@/base/mixins/form.mixin'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { CLICK2PAY_MC_ERROR_MESSAGES, CLICK2PAY_VIEW } from '@/base/const/click2pay.const'
import { MatomoClass } from '@/base/class/matomo.class'
import { MATOMO_C2P_ACTION, MATOMO_EVENT_CATEGORY, MATOMO_EVENT_TYPE } from '@/base/const/matomo.const'

export default {
  name: 'ClickToPayLoginForm',
  mixins: [formMixin],
  data () {
    return {
      formData: {
        email: null
      }
    }
  },
  computed: {
    ...mapState({
      processing: state => state.c2p.processing,
      idToken: state => state.c2p.idToken,
      isProcessActive: state => state.c2p.isProcessActive,
      selectedCard: state => state.c2p.selectedCard
    }),
    ...mapGetters({
      profile: 'getC2PProfile'
    })
  },
  methods: {
    ...mapMutations([
      'SET_C2P_PROCESSING',
      'SET_C2P_EMAIL',
      'SET_C2P_VIEW'
    ]),
    ...mapActions([
      'getC2PIdentityLookup',
      'getC2PUnbindAppInstance'
    ]),
    goBack () {
      if (!this.isProcessActive) {
        this.SET_C2P_VIEW(CLICK2PAY_VIEW.notRecognized)
        return
      }
      if (this.selectedCard) {
        this.SET_C2P_VIEW(CLICK2PAY_VIEW.cardSelected)
        return
      }
      this.SET_C2P_VIEW(CLICK2PAY_VIEW.newCard)
    },
    isFormInvalid () {
      if (this.form) {
        return this.form.invalid
      }
      return false
    },
    submit () {
      if (this.isFormInvalid()) {
        return false
      }
      this.SET_C2P_PROCESSING(true)
      this.SET_C2P_EMAIL(this.formData.email)
      this.getC2PUnbindAppInstance().catch(() => {})
      this.getC2PIdentityLookup()
        .catch(error => {
          switch (error.toString()) {
            // konto zablokowane
            case CLICK2PAY_MC_ERROR_MESSAGES.emailLocked:
              this.addErrorToField('email', 'emailLocked')
              break
            // email nierozpoznany / niezarejestrowany
            case CLICK2PAY_MC_ERROR_MESSAGES.emailNotRecognized:
              this.addErrorToField('email', 'emailNotRecognized')
              break
            // pozostale błędy
            default:
              this.addErrorToField('email', 'emailIdentityLookup')
          }
          this.SET_C2P_PROCESSING(false)
        })
        .finally(() => {
          this.SET_C2P_PROCESSING(false)
        })
    }
  },
  mounted () {
    MatomoClass.sendEvent([MATOMO_EVENT_TYPE.trackEvent, MATOMO_EVENT_CATEGORY.c2p, MATOMO_C2P_ACTION.loginView])
    if (this.$refs['email']) {
      this.$refs['email'].focus()
    }
    this.$emit('resetForm')
  },
  destroyed () {
    if (!this.isProcessActive) {
      this.$emit('resetCardWidget')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/base/assets/scss/components/PaywallForm.scss";
.c2p-action {
  button.btn.btn-plain {
    font-size: 12px;
    text-transform: unset;
  }
}
.submit-wrapper {
  padding-top: 10px;
  .c2p-submit {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.c2p-back {
  margin-top: 40px;
  display: flex;
  justify-content: center;

  button {
    font-size: 12px;
  }
}
</style>
